import httpRequest from '@/utils/request';
import axios from 'axios';


const CancelToken = axios.CancelToken;
const moduleUrl = '/Module';
const moduleUrlForRemind = `${moduleUrl}/remind`;
const generateUrlByModuleId = (moduleId: string): string => {
  return `/Module/${moduleId}`;
};
const updateLabelUrl = (moduleId: string): string => {
  return `/Module/${moduleId}/labels`;
};
const updateCommentUrl = (moduleId: string): string => {
  return `/Module/${moduleId}/comment`;
};
const settlementUrl = (moduleId: string): string => {
  return `/Module/${moduleId}/settles`;
};
const updateStatusUrl = (id: string): string => {
  return `${moduleUrl}/${id}/status`;
};

export const searchModules = (
  params: IModule.IRequest.ISearchModules,
): Promise<IModule.IResponse.IData> => {
  return httpRequest.get(moduleUrl, {
    params,
  });
};

export let cancel: any;
export const getModuleDetail = (
  params: IModule.IRequest.ISearchModules,
): Promise<IModule.IResponse.IData> => {
  return httpRequest.get(moduleUrl, {
    params,
    cancelToken: new CancelToken((c) => {
      cancel = c;
    }),
  });
};

export const updateModule = (
  params: IModule.IRequest.IUpdateModule,
): Promise<IResponseData.IBaseData> => {
  const url = generateUrlByModuleId(params.id);
  return httpRequest.post(url, params.data);
};
export const deleteModule = (moduleId: string): Promise<IResponseData.IBaseData> => {
  const url = generateUrlByModuleId(moduleId);
  return httpRequest.delete(url);
};
export const updateLabel = (params: IModule.IRequest.IUpdateLabels): Promise<IResponseData.IBaseData> => {
  const url = updateLabelUrl(params.moduleId);
  return httpRequest.post(url, params.labelIds);
};
export const deleteLabel = (params: IModule.IRequest.IUpdateLabels): Promise<IResponseData.IBaseData> => {
  const url = updateLabelUrl(params.moduleId);
  return httpRequest.delete(url, {
    data: params.labelIds,
  });
};

export const updateComment = (
  params: IModule.IRequest.IUpdateComment,
): Promise<IResponseData.IBaseData> => {
  const url = updateCommentUrl(params.moduleId);
  return httpRequest.post(url, params.data);
};

export const moduleSettles = (params: IModule.IRequest.ISettlement): Promise<IResponseData.IBaseData> => {
  const url = settlementUrl(params.moduleId);
  return httpRequest.put(url, params.todoIds);
};

export const completeModule = (id: string): Promise<IResponseData.IBaseData> => {
  const url = updateStatusUrl(id);
  return httpRequest.put(url, null, {
    params: {
      status: 'Completed',
    },
  });
};
export const closeModule = (id: string): Promise<IResponseData.IBaseData> => {
  const url = updateStatusUrl(id);
  return httpRequest.put(url, null, {
    params: {
      status: 'Closed',
    },
  });
};
export const cancelModule = (id: string): Promise<IResponseData.IBaseData> => {
  const url = updateStatusUrl(id);
  return httpRequest.put(url, null, {
    params: {
      status: 'Cancel',
    },
  });
};
export const getModuleListForRemind = (): Promise<IModule.IResponse.IData> => {
  return httpRequest.get(moduleUrlForRemind);
};
